<template>
  <div>
    <ul class="nav nav-tabs">
      <li :class="{'active' : tab === 'personal'}">
        <a
          href="#"
          @click="setTab('personal', $event)">Личные данные</a>
      </li>
      <li :class="{'active' : tab === 'password'}">
        <a
          href="#"
          @click="setTab('password', $event)">Смена пароля</a>
      </li>
      <li :class="{'active' : tab === 'profiles'}">
        <a
          href="#"
          @click="setTab('profiles', $event)">Профили покупателей</a>
      </li>
    </ul>

    <div class="tab-content">
      <div
        class="tab-pane fade in active">
        <component :is="componentName"/>
      </div>
    </div>
  </div>
</template>

<script>
  import PersonalData from './PersonalProfile/PersonalData'
  import ChangePassword from './PersonalProfile/ChangePassword'
  import Profiles from './PersonalProfile/Profiles'

  export default {
    name: 'PersonalProfile',
    components: {Profiles, ChangePassword, PersonalData},
    data: function () {
      return {
        params: this.application,
        tab: 'personal'
      }
    },
    computed: {
      componentName: function () {
        switch (this.tab) {
          case 'password':
            return 'ChangePassword'
          case 'profiles':
            return 'Profiles'
          default:
            return 'PersonalData'
        }
      }
    },
    methods: {
      setTab: function (tab, $event) {
        $event.preventDefault()
        this.tab = tab
      }
    }
  }
</script>

<style
  lang="scss"
  scoped>

</style>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile.vue